// extracted by mini-css-extract-plugin
export default {"loaderWrap":"edit-entry-modal_loaderWrap__it8ij","loaderText":"edit-entry-modal_loaderText__tuqgi"};